import React, { useEffect, useState } from 'react'
import { CButton, CCard, CCardBody, CCol, CForm, CRow } from '@coreui/react'
import SalesTemplate from './RecommendationFormTemplates/SalesTemplate'
import { wtApiCall } from 'src/helpers/commons/ApiWrapper'
import {
  lzNotifyErrorMessageFromResult,
  lzNotifySuccessMessage,
} from 'src/helpers/commons/notifications'
import StaffTemplate from './RecommendationFormTemplates/StaffTemplate'
import StaffOutletTemplate from './RecommendationFormTemplates/StaffOutletTemplate'
import CafeteriaStaffTemplate from './RecommendationFormTemplates/CafeteriaStaffTemplate'
import OfficerTemplate from './RecommendationFormTemplates/OfficerTemplate'
import Loading from 'src/helpers/commons/loader'
import OutletLabTemplate from './RecommendationFormTemplates/OutletLabTemplate'
import StaffV2Template from './RecommendationFormTemplates/StaffV2Template'
import CafeteriaStaffV2Template from './RecommendationFormTemplates/CafeteriaStaffV2Template'
import RecommendationEvaluationTemplate from './RecommendationFormTemplates/RecommendationEvaluationTemplate'

export default function RecommendationForm(props) {
  const { onClose, editId } = props
  const [remarks, setRemarks] = useState('')
  const [isDisabled, setIsDisabled] = useState(false)
  const [viewOnly, setViewOnly] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [totalRating, setTotalRating] = useState(0)
  const [submittedRating, setSubmittedRating] = useState(null)
  const [record, setRecord] = useState(null)
  const [templateFields, setTemplateFields] = useState(null)
  const [template, setTemplate] = useState(props.template)

  const [salesTemplate, setSalesTemplate] = useState({
    written_expression: 0,
    output_of_work: 0,
    responsibility: 0,
    sales_target: 0,
    targets_achieved: 0,
    sales_growth: 0,
    order_confirmed: 0,
    monthly_calls: 0,
    cases_processed: 0,
    quotations_served: 0,
    lost_sales: 0,
    monthly_attendance: 0,
  })

  const [staffTemplate, setStaffTemplate] = useState({
    punctuality: 0,
    devotion_to_duty: 0,
    team_spirit: 0,
    appearance_and_bearing: 0,
    responsibility_and_initiative: 0,
    organizing_ability: 0,
    reliability: 0,
    alertness_and_intelligence: 0,
    behaviour_with_colleagues: 0,
    attendance_and_time_keeping: 0,
    knowledge_of_work: 0,
  })

  const [staffV2Template, setStaffV2Template] = useState({
    punctuality_attendance_and_time_keeping: 0,
    devotion_to_duty: 0,
    team_spirit: 0,
    appearance_and_bearing: 0,
    responsibility_and_initiative: 0,
    organizing_ability: 0,
    reliability: 0,
    alertness_and_intelligence: 0,
    behaviour_with_colleagues: 0,
    knowledge_of_work: 0,
  })

  const [staffOutletTemplate, setStaffOutletTemplate] = useState({
    punctuality: 0,
    devotion_to_duty: 0,
    team_spirit: 0,
    client_handling: 0,
    successful_leads: 0,
    complaint_handling: 0,
    customer_services: 0,
    maintaining_of_record: 0,
    maintenance_of_outlets: 0,
    display_of_products: 0,
  })

  const [cafeteriaStaffTemplate, setCafeteriaStaffTemplate] = useState({
    punctuality: 0,
    devotion_to_duty: 0,
    team_spirit: 0,
    appearance: 0,
    effective_at_time: 0,
    follows_food_guidelines: 0,
    communication: 0,
    alertness_and_intelligence: 0,
    behaviour_with_colleagues: 0,
    attendance_and_time_keeping: 0,
    knowledge_of_work: 0,
  })

  const [cafeteriaStaffV2Template, setCafeteriaStaffV2Template] = useState({
    punctuality_attendance_and_time_keeping: 0,
    devotion_to_duty: 0,
    team_spirit: 0,
    appearance: 0,
    effective_at_time: 0,
    follows_food_guidelines: 0,
    communication: 0,
    alertness_and_intelligence: 0,
    behaviour_with_colleagues: 0,
    knowledge_of_work: 0,
  })

  const [officerTemplate, setOfficerTemplate] = useState({
    work_output: 0,
    work_quality: 0,
    emotional_stability: 0,
    tolerance: 0,
    reliability: 0,
    judgement: 0,
    written_expression: 0,
    clarity_of_thoughts: 0,
    ability: 0,
    supervision_and_Guidance: 0,
    relation_with_Superiors: 0,
  })
  const [outletLabTemplate, setOutletLabTemplate] = useState({
    job_understanding: 0,
    devotion_to_duty: 0,
    job_skills: 0,
    successful_leads: 0,
    attendance: 0,
    dependability: 0,
    attitude: 0,
    maintenance_of_outlets: 0,
    display_of_products: 0,
    services: 0,
    cooperation_with_colleagues: 0,
    marketing_skills: 0,
  })

  const onChange = (key, value) => {
    setSalesTemplate({ ...salesTemplate, [key]: value })
    setStaffTemplate({ ...staffTemplate, [key]: value })
    setStaffV2Template({ ...staffV2Template, [key]: value })
    setStaffOutletTemplate({ ...staffOutletTemplate, [key]: value })
    setCafeteriaStaffTemplate({ ...cafeteriaStaffTemplate, [key]: value })
    setCafeteriaStaffV2Template({ ...cafeteriaStaffV2Template, [key]: value })
    setOfficerTemplate({ ...officerTemplate, [key]: value })
    setOutletLabTemplate({ ...outletLabTemplate, [key]: value })
  }

  const onChangeDynamicFields = (key, value, index) => {
    const record = [...templateFields]
    record[index].recommended_ratings = value
    setTemplateFields(record)
  }

  const getData = () => {
    if (editId !== 0) {
      wtApiCall(
        'performance_evaluations/' + editId,
        {},
        'get',
        (response) => {
          const { data } = response
          const { template_name } = data
          setRecord(data)
          const ratings = JSON.parse(data.recommended_ratings ? data.recommended_ratings : data.ratings)
          setSubmittedRating(ratings)
          setRemarks(remarks)
          if (template_name === 'salesTemplate') {
            setSalesTemplate({ ...salesTemplate, ...ratings })
          }
          if (template_name === 'staffTemplate') {
            setStaffTemplate({ ...staffTemplate, ...ratings })
          }
          if (template_name === 'staffV2Template') {
            setStaffV2Template({ ...staffV2Template, ...ratings })
          }
          if (template_name === 'staffOutletTemplate') {
            setStaffOutletTemplate({ ...staffOutletTemplate, ...ratings })
          }
          if (template_name === 'cafeteriaStaffTemplate') {
            setCafeteriaStaffTemplate({ ...cafeteriaStaffTemplate, ...ratings })
          }
          if (template_name === 'cafeteriaStaffV2Template') {
            setCafeteriaStaffV2Template({ ...cafeteriaStaffV2Template, ...ratings })
          }
          if (template_name === 'officerTemplate') {
            setOfficerTemplate({ ...officerTemplate, ...ratings })
          }
          if (template_name === 'outletLabTemplate') {
            setOutletLabTemplate({ ...outletLabTemplate, ...ratings })
          }
          if (template_name === 'dynamic') {
            const updatedRatings = ratings.map((item) => ({
              ...item,
              recommended_ratings: item.ratings
            }));

            setTemplateFields(updatedRatings);
          }
          setIsLoading(false)
        },
        (error) => {
          lzNotifyErrorMessageFromResult(error)
        },
      )
    } else {
      setIsLoading(false)
    }
  }

  const save = () => {
    let ratingFactors
    if (template === 'salesTemplate') {
      ratingFactors = salesTemplate
    }
    if (template === 'staffTemplate') {
      ratingFactors = staffTemplate
    }
    if (template === 'staffV2Template') {
      ratingFactors = staffV2Template
    }
    if (template === 'staffOutletTemplate') {
      ratingFactors = staffOutletTemplate
    }
    if (template === 'cafeteriaStaffTemplate') {
      ratingFactors = cafeteriaStaffTemplate
    }
    if (template === 'cafeteriaStaffV2Template') {
      ratingFactors = cafeteriaStaffV2Template
    }
    if (template === 'officerTemplate') {
      ratingFactors = officerTemplate
    }
    if (template === 'outletLabTemplate') {
      ratingFactors = outletLabTemplate
    }
    if (template === 'dynamic') {
      ratingFactors = templateFields
    }

    setIsDisabled(true)
    wtApiCall(
      'performance_evaluations/' + editId,
      {
        ratings: JSON.stringify(ratingFactors),
        total_ratings: totalRating,
        remarks: remarks,
        template: template,
        action: 'recommendation',
      },
      'put',
      (response) => {
        setIsDisabled(false)
        lzNotifySuccessMessage(response.data)
        onClose()
      },
      (error) => {
        setIsDisabled(false)
        lzNotifyErrorMessageFromResult(error)
        if (error.hasOwnProperty('errors')) {
          setErrors(error.errors)
        }
      },
    )
  }
  useEffect(() => {
    getData()
  }, [])

  if (isLoading) {
    return Loading
  }
  return (
    <>
      <CRow>
        <CCol md={12}>
          <CCard className="card-dark">
            <CCardBody>
              <h4> Recommend Performence Evaluation</h4>
              <br />
              <CRow>
                <CCol md={3}>
                  <label htmlFor="">
                    <strong>Employee Name:</strong>{' '}
                    <span style={{ color: 'blue' }}>{record.employee.full_name}</span>{' '}
                  </label>
                </CCol>
                <CCol md={3}>
                  <label htmlFor="">
                    <strong>File No:</strong>{' '}
                    <span style={{ color: 'blue' }}>{record.employee.personal_file_no}</span>{' '}
                  </label>
                </CCol>
                <CCol md={3}>
                  <label htmlFor="">
                    <strong>Department:</strong>{' '}
                    <span style={{ color: 'blue' }}>{record.employee.department.name}</span>{' '}
                  </label>
                </CCol>
                <CCol md={3}>
                  <label htmlFor="">
                    <strong>Designation:</strong>{' '}
                    <span style={{ color: 'blue' }}>{record.employee.designation.name}</span>{' '}
                  </label>
                </CCol>
              </CRow>
              <CForm>
                {template === 'salesTemplate' && (
                  <SalesTemplate
                    ratingData={salesTemplate}
                    setRatingData={setSalesTemplate}
                    onChange={onChange}
                    submittedRating={submittedRating}
                  />
                )}
                {template === 'staffTemplate' && (
                  <StaffTemplate
                    ratingData={staffTemplate}
                    setRatingData={setStaffTemplate}
                    onChange={onChange}
                    submittedRating={submittedRating}
                  />
                )}
                {template === 'staffV2Template' && (
                  <StaffV2Template
                    ratingData={staffV2Template}
                    setRatingData={setStaffV2Template}
                    onChange={onChange}
                    submittedRating={submittedRating}
                  />
                )}
                {template === 'staffOutletTemplate' && (
                  <StaffOutletTemplate
                    ratingData={staffOutletTemplate}
                    setRatingData={setStaffOutletTemplate}
                    onChange={onChange}
                    submittedRating={submittedRating}
                  />
                )}
                {template === 'cafeteriaStaffTemplate' && (
                  <CafeteriaStaffTemplate
                    ratingData={cafeteriaStaffTemplate}
                    setRatingData={setCafeteriaStaffTemplate}
                    onChange={onChange}
                    submittedRating={submittedRating}
                  />
                )}
                {template === 'cafeteriaStaffV2Template' && (
                  <CafeteriaStaffV2Template
                    ratingData={cafeteriaStaffV2Template}
                    setRatingData={setCafeteriaStaffV2Template}
                    onChange={onChange}
                    submittedRating={submittedRating}
                  />
                )}
                {template === 'officerTemplate' && (
                  <OfficerTemplate
                    ratingData={officerTemplate}
                    setRatingData={setOfficerTemplate}
                    onChange={onChange}
                    submittedRating={submittedRating}
                  />
                )}
                {template === 'outletLabTemplate' && (
                  <OutletLabTemplate
                    ratingData={outletLabTemplate}
                    setRatingData={setOutletLabTemplate}
                    onChange={onChange}
                    submittedRating={submittedRating}
                  />
                )}
                {template === 'dynamic' && (
                  <RecommendationEvaluationTemplate
                    templateFields={templateFields}
                    onChange={onChange}
                    onChangeDynamicFields={onChangeDynamicFields}

                  />
                )}
                <span>
                  <b>Remarks</b>
                </span>
                <textarea
                  className="form-control"
                  style={{ resize: 'none' }}
                  onChange={(event) => setRemarks(event.target.value)}
                  readOnly={viewOnly}
                  value={remarks}
                />
                <br></br>
                {!viewOnly && (
                  <>

                    <CButton style={{ float: 'right', marginLeft: '10px' }} color="warning" onClick={() => onClose()}>
                      Close
                    </CButton>
                    <CButton
                      color="primary"
                      style={{ float: 'right' }}
                      onClick={() => save()}
                      disabled={isDisabled}
                    >
                      Save
                    </CButton>

                  </>
                )}
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  )
}
